<template>
  <div>
    <v-form>
      <v-row>
        <v-col>
          <v-dialog
            ref="dialog"
            v-model="dateModal"
            :return-value.sync="form.date"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="form.date"
                label="Fecha"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="form.date"
              scrollable
              first-day-of-week="1"
              locale="es"
              :max="maxDate"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dateModal = false"
                >Cancelar</v-btn
              >
              <v-btn text color="primary" @click="$refs.dialog.save(form.date)"
                >Cerrar</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col>
          <v-text-field
            label="Presión arterial"
            v-model="form.blood_pressure"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field label="Peso" v-model="form.weight" />
        </v-col>
        <v-col>
          <v-text-field label="I. M. C." readonly v-model="form.bmi" />
        </v-col>
        <v-col>
          <v-text-field label="Cintura" v-model="form.waist_1" />
        </v-col>
        <v-col>
          <v-text-field label="Cadera" v-model="form.waist_2" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field label="Grasa total" v-model="form.total_fat" />
        </v-col>
        <v-col>
          <v-text-field label="Músculo" v-model="form.muscle" />
        </v-col>
        <v-col>
          <v-text-field label="Grasa visceral" v-model="form.visceral_fat" />
        </v-col>
        <v-col>
          <v-text-field label="KCal" v-model="form.kilocalories" />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import moment from "moment";
import calculateBmi from "@/utils/calculateBmi";

export default {
  name: "Measure",
  props: {
    measure: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.measure,
      dateModal: false,
      maxDate: moment().format("YYYY-MM-DD"),
    };
  },
  methods: {
    updateMeasures() {
      this.openLoader();
      const request = this.sendRequest(
        this.$store.state.apiUrl +
          "catalogs/patients/" +
          this.form.patient_id +
          "/measures/" +
          this.measure.id,
        this.form,
        "PUT",
      );
      request
        .then(({ message }) => {
          this.showSuccessMessage(message);
          this.clearForm(this.form);
          this.$store.commit('measure/changeFormStatus', false);
          this.$emit("close");
        })
        .finally(this.closeLoader());
    },
  },
  watch: {
    form: {
      handler(val) {
        this.form.bmi = calculateBmi(val.weight, 1.6);
      },
      deep: true,
    },
    "$store.state.measure.isFormSent": {
      inmediate: true,
      handler(val) {
        if (true === val) {
          this.updateMeasures();
        }
      },
    },
  },
};
</script>
